function identity(x) {
  return x;
}

/**
 *
 * @param {number[]} values
 * @param {number} N
 * @param {Function} accessor
 * @returns {Array[number]}
 */
export function movingAverage(values, N, accessor = identity) {
  let i = 0;
  let sum = 0;
  const means = new Array(values.length).fill(NaN);

  for (let n = Math.min(N - 1, values.length); i < n; ++i) {
    sum += accessor(values[i]);
  }

  for (let n = values.length; i < n; ++i) {
    sum += accessor(values[i]);
    means[i] = sum / N;
    sum -= values[i - N + 1];
  }

  return means;
}
